import '../auth.scss';

import { verifyEmail } from '@basqet-dashboard/common/api';
import { ReactComponent as Success } from '@basqet-dashboard/common/assets/icons/success.svg';
import { ReactComponent as Logo } from '@basqet-dashboard/common/assets/logo.svg';
import { Button } from '@basqet-dashboard/common/components';
import { useDocumentTitle } from '@basqet-dashboard/common/hooks';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { toast } from 'react-toastify';

function VerifyEmail() {
  const [isLoading, setIsLoading] = useState(true);

  const { search } = useLocation();
  useEffect(async () => {
    const query = new URLSearchParams(search);
    const email = query.get('email');
    const token = query.get('token');
    const type = query.get('type');
    try {
      if (type === 'passwordReset') {
        window.location.replace(`/reset-password?email=${email}&token=${token}`);
      }
      await verifyEmail({ email, token });
      setIsLoading(false);
    } catch (error) {
      window.location.replace('/login');
      toast.error((error.response && error.response.data.message) || 'Network Error');
    }
  }, []);

  useDocumentTitle('Setup');
  return (
    <div className="auth">
      <div className="auth__content">
        <Logo />
        <h1 className="page__title">
          Almost <span className="text-cursive">there!</span>
        </h1>
        {!isLoading ? (
          <div className="auth__card">
            <div className="auth__success">
              <Success role="img" />
              <h3>Email verified</h3>
              <Button isFull type="button" onClick={() => window.location.replace('/login')}>
                Back to Login page
              </Button>
            </div>
          </div>
        ) : (
          <div className="auth__card">
            <div className="auth__success">
              <h3>Email is being verified</h3>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export { VerifyEmail };
